import { graphql } from '~gql';

export const LOGIN_WITH_GOOGLE_CODE = graphql(`
  mutation LoginWithGoogleCode($input: LoginWithGoogleCodeInput!) {
    loginWithGoogleCode(input: $input) {
      token
      user {
        ...SessionUser
      }
    }
  }
`);
